var hasStatisticsConsent = function hasStatisticsConsent() {
  var _window$Cookiebot;
  if (typeof window === 'undefined') return false;
  return Boolean((_window$Cookiebot = window.Cookiebot) === null || _window$Cookiebot === void 0 || (_window$Cookiebot = _window$Cookiebot.consent) === null || _window$Cookiebot === void 0 ? void 0 : _window$Cookiebot.statistics);
};
export default hasStatisticsConsent;